// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"304593de","551":"ae870ec7","851":"df73ed9a"}[chunkId] + ".chunk.js";
};